import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Creators from "./components/Creators";
import FeaturedProjects from "./components/FeaturedProjects";
import WhyClickory from "./components/WhyClickory";
import OurProcess from "./components/OurProcess";
import Testimonials from "./components/Testimonials";
import Services from "./components/Services";
import FAQ from "./components/FAQ";
import Founder, { LetsPackage, LetsConnect } from "./components/Founder";
import { useRevealObserver } from "./hooks/useInView";

function Home() {
  useRevealObserver();
  useEffect(() => {
    document.title = "Clickory — YouTube Packaging Built To Earn More Clicks";
  }, []);
  return (
    <div className="bg-app">
      <Header />
      <main>
        <Hero />
        <Creators />
        <FeaturedProjects />
        <WhyClickory />
        <OurProcess />
        <Testimonials />
        <Services />
        <FAQ />
        <Founder />
        <LetsPackage />
        <LetsConnect />
      </main>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
